import { useEffect, useMemo, useState } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import { toModalImage } from 'Pods/ThreeDStudio/Shared/ImageModal/Utils/toModalImage'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const SIMILAR_IMAGES_PER_PAGE = 8

// Images that look like the opened one, keyed on its output asset. The endpoint answers 401
// to a signed-out viewer, so the caller passes a null asset id until there is a session and
// nothing is requested. Images without a file to show are dropped, as is the opened image
// itself should the search return it.
function useSimilarImages(assetId, slug) {
  const { getData } = useApiGet()
  const [loaded, setLoaded] = useState(null)

  useEffect(() => {
    if (!assetId) return

    getData({
      path: '/api/internal/generator/similar-images',
      params: { asset_id: assetId, per_page: SIMILAR_IMAGES_PER_PAGE },
      onSuccess: (response) => {
        setLoaded({ assetId, items: response?.data?.data ?? EMPTY_ARRAY })
      },
    })
  }, [getData, assetId])

  // Keyed on the asset so the previous image's results never show while the next ones load.
  const items = assetId && loaded?.assetId === assetId ? loaded.items : EMPTY_ARRAY

  return useMemo(() => {
    if (items.length === 0) return EMPTY_ARRAY

    return items
      .map(item => toModalImage(item?.attributes))
      .filter(image => image && image.slug !== slug)
  }, [items, slug])
}

export default useSimilarImages
